import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IJSONAPIItem, IAPIError, IDataKeys } from "shared/types";
import { IBandIcalParams } from "Bands/types";

export interface IJSONAPIBandIcalCollection {
  [IDataKeys.ical]: any;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class BandIcalService {
  static getExistingBandIcal = (
    band: string,
    user?: string
  ): Promise<IJSONAPIBandIcalCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.ICALS,
          data: {
            band,
            user,
          },
        });

        resolve(response as IJSONAPIBandIcalCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_BAND_ICALS);
        reject(error);
      }
    });

  static editBandIcal = ({
    id,
    data,
  }: {
    id: string;
    data: IBandIcalParams;
  }): Promise<IJSONAPIBandIcalCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.ICAL(id),
          data,
        });

        resolve(response as IJSONAPIBandIcalCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_BAND_ICALS);
        reject(error);
      }
    });

  static getBandIcals = ({
    title,
    band,
    user,
    data,
  }: {
    title: string;
    band: string;
    user?: string;
    data?: IBandIcalParams;
  }): Promise<IJSONAPIBandIcalCollection> =>
    new Promise(async (resolve, reject) => {
      let iCalData = await BandIcalService.getExistingBandIcal(band, user);

      if (!iCalData.ical || iCalData.ical.length === 0) {
        try {
          const response: unknown = await APIService.post({
            path: API_ENDPOINTS.ICALS,
            data: {
              title,
              band,
              user,
              ...data,
            },
          });

          iCalData = response as IJSONAPIBandIcalCollection;
        } catch (error) {
          (error as IAPIError).errorCodes?.push(
            API_ERROR_CODES.POST_BAND_ICALS
          );
          reject(error);
        }
      }

      resolve(iCalData);
    });
}
